import React, { useContext } from 'react';
import { Modal } from 'antd';

import QuestionarioContextProvider from '../../../../hooks/useQuestionario';
import { Button, MasterDetailForm, Row, Widget } from '@digital/ui';
import { FinalizarEtapaDadosQuestionario } from '@app/api/demanda';

const ModalFinalizarEtapaDados = () => {

  const {
    demandaData,
    exibirModalFinalizarEtapaDados,
    setExibirModalFinalizarEtapaDados,
    setUpdate,
    update,
    minAprovacaoGpc,
    isAdmContrato,
    isGPC,
  } = useContext(QuestionarioContextProvider);

  const onDiscordar = () => {
    setExibirModalFinalizarEtapaDados(false);
  };
  const onConcordar = () => {
    FinalizarEtapaDadosQuestionario({ id: demandaData.id }).then(data => {
      setExibirModalFinalizarEtapaDados(false);
      setUpdate(!update);
    });
  };

  return exibirModalFinalizarEtapaDados ? (
    <Modal
      title="Confirmar"
      id="mrn-modal-ModalFinalizarEtapaDados"
      width="680px"
      visible={exibirModalFinalizarEtapaDados}
      onCancel={() => setExibirModalFinalizarEtapaDados(false)}
      footer={null}>
      <MasterDetailForm
        actions={[
          <Button key="discordarBtn" id="mrn-button-nao-ModalFinalizarEtapaDados" type="link" onClick={() => onDiscordar()}>
            Não
          </Button>,
          <Button key="concordarBtn" id="mrn-button-sim-ModalFinalizarEtapaDados" type="primary" onClick={() => onConcordar()}>
            Sim
          </Button>,
        ]}>
        <Widget>
          <Row>
            <p style={{ textAlign: 'center', paddingTop: '50px', paddingBottom: '50px' }}>
              {
                isAdmContrato
                  ? 'Questionário concluído, deseja seguir com a validação do Gestor Técnico?'
                  : demandaData && demandaData.expectativaValorFinal >= (minAprovacaoGpc || 0)
                    ? 'Questionário concluído, deseja seguir com a validação da documentação?'
                    : 'Questionário concluído, deseja seguir com a emissão da Requisição?'

              }
            </p>
          </Row>
        </Widget>
      </MasterDetailForm>
    </Modal>
  ) : <></>;
};

export default ModalFinalizarEtapaDados;
